import React, { useEffect, useMemo, useState } from 'react';
import cs from 'classnames';
import styles from './index.module.scss';
import { Icon } from '@shakkerai/components';

export const LABEL_LEVEL = {
  l1: 1,
  l2: 2,
};

const level2LabelList = [
  {
    category: '写实摄影',
    categoryCode: '100028',
    alias: '摄影滤镜',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '插画设计',
    categoryCode: '100030',
    alias: '经典艺术',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '插画设计',
    categoryCode: '100030',
    alias: '国风国潮',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '动漫游戏',
    categoryCode: '100027',
    alias: '动漫画风',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '3D立体',
    categoryCode: '100038',
    alias: '手工艺品',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: 'CG幻想',
    categoryCode: '100037',
    alias: 'CG画风',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '电商视觉',
    categoryCode: '100032',
    alias: '海报设计',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
  {
    category: '建筑空间',
    categoryCode: '100033',
    alias: '空间设计',
    includedTags: null,
    displayCount: 4,
    codes: [''],
  },
];

const Label = ({ item, menus, setMenus }) => {
  const chooseL2 = () => {
    const newMenus = [...menus].map((l1) => ({
      ...l1,
      choosed: false,
      children:
        l1.children &&
        l1.children.map((l2) => ({
          ...l2,
          choosed: false,
          children:
            l2.children &&
            l2.children.map((l3) => {
              l3.choosed = l3.id === item.id;
              return l3;
            }),
        })),
    }));
    setMenus(newMenus);
  };
  return (
    <div
      onClick={() => chooseL2()}
      className="flex-shrink-0 h-6 border border-[#EEE] text-[#2D2D2D] text-[13px] rounded leading-6 text-center px-2 mr-3 cursor-pointer hover:bg-[#F6F6F6]"
    >
      {item.tagLabel}
    </div>
  );
};

export const Labels = React.memo(({ menuPath, ...props }) => {
  const L3list = useMemo(() => {
    const { menu } = menuPath;
    const target = menu?.children.find((child) => child.choosed);
    return target?.children && target?.children?.length > 1 ? target?.children : [];
  }, [menuPath]);
  return (
    <div className="flex overflow-x-auto">
      {L3list?.map((item, idx) => (
        <Label item={item} key={idx} {...props} />
      ))}
    </div>
  );
});

export default Labels;
